import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_staff/software/_layout/alerts/_alerts/shadow-it/_shadow-it/",
)({
  beforeLoad: () => {
    throw redirect({ to: "/software/alerts/shadow-it/apps" });
  },
});
